import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById('first-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-152" data-mp="boonn90ts56l">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_rgba(10,22,40,0.15)] backdrop-blur md:inset-x-auto md:bottom-6 md:right-6 md:rounded-2xl md:bg-transparent md:p-0 md:shadow-none md:backdrop-blur-none" data-id="element-153" data-mp="196ol2f92h8w0">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-xl bg-cta px-6 py-4 font-display text-lg font-semibold uppercase tracking-wide text-white shadow-[0_5px_0_0_#0F6E32] hover:bg-cta-hover md:shadow-[0_5px_0_0_#0F6E32,0_12px_30px_rgba(10,22,40,0.3)]" data-id="element-154" data-mp="26ap3tuopalcf">
            <span className="whitespace-nowrap" data-id="element-155" data-mp="1ig4j15isw0ef">Get it now · Only $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-156" data-mp="1nd4pvinh576l" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}